import Layout from "@/page/index";

const pipe = x => () => import(/* webpackChunkName: "views" */ `@/views/${x}`);

export default [
  {
    path: "/memberNew/mobileCrypto",
    component: Layout,
    redirect: "/memberNew/mobileCrypto/index",
    children: [
      {
        path: "index",
        name: "手机号加密工具",
        component: pipe("memberNew/mobileCrypto/index")
      }
    ]
  },
  {
    path: "/wel",
    component: Layout,
    redirect: "/wel/index",
    children: [
      {
        path: "index",
        name: "首页",
        meta: { i18n: "dashboard" },
        component: pipe("wel/index")
      },
      {
        path: "/rabbit/metting-detail",
        name: "会议详情",
        meta: { $keepAlive: true, i18n: "mettingDetail" },
        component: pipe("rabbit/metting-detail")
      },
      {
        path: "/rabbit/user-detail",
        name: "用户详情",
        meta: { $keepAlive: true, i18n: "userDetail" },
        component: pipe("rabbit/user-detail")
      },
      {
        path: "/rabbit/cloud-app",
        name: "云应用详情",
        meta: { $keepAlive: true, i18n: "cloud-app" },
        component: pipe("rabbit/cloud-app")
      },
      {
        path: "/imageManagement/mirrorListDetails",
        name: "投屏列表-详情页",
        meta: { $keepAlive: true, i18n: "mirrorListDetails" },
        component: pipe("imageManagement/mirrorListDetails")
      },
      {
        path: "/imageManagement/mirrorUserDetails",
        name: " 投屏用户-详情页",
        meta: { $keepAlive: true, i18n: "mirrorUserDetails" },
        component: pipe("imageManagement/mirrorUserDetails")
      },
      {
        path: "/mediaManage/mediaContentManage/editDialog",
        name: "新增编辑媒资",
        meta: { $keepAlive: true, keepAlive: true, i18n: "mediaContentManage_editDialog" },
        component: pipe("mediaManage/mediaContentManage/editDialog")
      },
      {
        path: "/bigData/userClustering/addUserClustering",
        name: "新增编辑用户分群",
        meta: { $keepAlive: true, i18n: "addUserClustering" },
        component: pipe("bigData/userClustering/addUserClustering")
      },
      {
        path: "/bigData/qualityMonitoringConfig/config/addConfig",
        name: "新增编辑监控规则",
        meta: { $keepAlive: true, i18n: "qualityMonitoringConfigAddConfig" },
        component: pipe("bigData/qualityMonitoringConfig/config/addConfig")
      }
    ]
  },
  {
    path: "/dict-horizontal",
    component: Layout,
    redirect: "/dict-horizontal/index",
    children: [
      {
        path: "index",
        name: "字典管理",
        meta: { i18n: "dict" },
        component: pipe("util/demo/dict-horizontal")
      }
    ]
  },
  {
    path: "/authority",
    component: Layout,
    redirect: "/authority/authorize",
    children: [
      {
        path: "/authority/authorize",
        name: "roleAuthorize",
        meta: { i18n: "dict" },
        component: pipe("authority/authorize-config")
      }
    ]
  },
  {
    path: "/dict-vertical",
    component: Layout,
    redirect: "/dict-vertical/index",
    children: [
      {
        path: "index",
        name: "字典管理",
        meta: { i18n: "dict" },
        component: pipe("util/demo/dict-vertical")
      }
    ]
  },
  {
    path: "/info",
    component: Layout,
    redirect: "/info/index",
    children: [
      {
        path: "index",
        name: "个人信息",
        meta: { i18n: "info" },
        component: pipe("system/userinfo")
      }
    ]
  },
  {
    path: "/work/process/leave",
    component: Layout,
    redirect: "/work/process/leave/form",
    children: [
      {
        path: "form/:processDefinitionId",
        name: "请假流程",
        meta: { i18n: "work" },
        component: pipe("work/process/leave/form")
      },
      {
        path: "handle/:taskId/:processInstanceId/:businessId",
        name: "处理请假流程",
        meta: { i18n: "work" },
        component: pipe("work/process/leave/handle")
      },
      {
        path: "detail/:processInstanceId/:businessId",
        name: "请假流程详情",
        meta: { i18n: "work" },
        component: pipe("work/process/leave/detail")
      }
    ]
  },
  {
    path: "/mediaManage/mediaContentManage/components",
    component: Layout,
    redirect: "/mediaManage/mediaContentManage/components/detail",
    children: [
      {
        path: "detail/",
        name: "媒资内容详情",
        meta: { i18n: "mediaManage" },
        component: pipe("mediaManage/mediaContentManage/components/detail")
      }
    ]
  },
  {
    path: "/mediaOrder",
    component: Layout,
    redirect: "/mediaOrder/index",
    children: [
      {
        path: "index/:id",
        name: "媒资订单",
        meta: { i18n: "mediaOrder" },
        component: pipe("mediaOrder/index")
      }
    ]
  },
  {
    path: "/bigData/demo",
    component: Layout,
    redirect: "/bigData/demo/index",
    children: [
      {
        path: "index",
        name: "大数据用户关系demo",
        component: pipe("bigData/demo/index")
      }
    ]
  },
  {
    path: "/memberNew/activeCode/activeCodeGenerate",
    component: Layout,
    redirect: "/memberNew/activeCode/activeCodeGenerate/index",
    children: [{
      path: "index/:id",
      name: "激活码生成",
      meta: {
        i18n: "activeCodeGenerate"
      },
      component: pipe("activeCodeGenerate/index")
    }]
  },
  {
    path: "/aiSession",
    component: Layout,
    redirect: "/aiSession/index",
    children: [
      {
        path: "index",
        name: "AI会话管理",
        meta: { i18n: "aiSession" },
        component: pipe("aiSession/index")
      },
      {
        path: "messages",
        name: "AI会话消息",
        meta: { i18n: "aiSessionMessages" },
        component: pipe("aiSession/messages")
      },
      {
        path: "tasks",
        name: "AI会话任务",
        meta: { i18n: "aiSessionTasks" },
        component: pipe("aiSession/tasks")
      },
      {
        path: "taskQuery",
        name: "任务查询",
        meta: { i18n: "aiSessionTaskQuery" },
        component: pipe("aiSession/taskQuery")
      }
    ]
  },
  {
    path: "/fastCommand",
    component: Layout,
    redirect: "/fastCommand/index",
    children: [
      {
        path: "index",
        name: "快捷命令管理",
        meta: { i18n: "fastCommand" },
        component: pipe("fastCommand/index")
      }
    ]
  },
];
